export default __webpack_public_path__ + "static/media/marseilleairbus.355ee992.png";